<template>
  <v-card elevation="0" outlined class="d-flex flex-column h-100" min-height="350">
    <v-card-title class="py-1 white--text d-flex align-center justify-space-between" :class="$vuetify.theme.dark ? 'black' : 'primary'">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">art_track</v-icon>
        <span class="white--text body-font body-1 font-weight-bold text-uppercase">{{ $t("app.videoPlaylists") }}</span>
      </div>
      <v-btn class="pl-0 pr-0" text small :to="`/video-playlists`">
        <span class="white--text text-decoration-underline font-weight-bold">{{$t('general.seeAll')}}</span>
        <v-icon small class="ml-1" color="white">keyboard_arrow_right</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="d-flex flex-column pb-1 flex-grow-1">
      <template v-if="!loading">
        <v-data-table dense disable-items-per-page 
          :headers="headers" 
          :items="playlists"
          :footer-props="{ itemsPerPageOptions: $vuetify.breakpoint.smAndDown ? [1] : [6]}"
          class="pa-0"
          :loading="loading"
        >
          <!--Name-->
          <template v-slot:item.name="{ item }">
            <router-link :to="`/video-highlights/playlist/${item.id}`" target="_blank">
              <span class="font-weight-medium primary--text body-1">{{ item.name }}</span>
            </router-link>
          </template>
          <!--Created-->
          <template v-slot:item.createdTime="{ item }">
            <span class="body-1">{{ item.createdAt }}</span>
          </template>
          <!--Used-->
          <template v-slot:item.usedTime="{ item }">
            <span class="body-1">{{ item.usedAt }}</span>
          </template>
        </v-data-table>
      </template>

      <!-- Skeleton Loader -->
      <template v-else>
        <div class="mt-4 pl-6 pr-4 d-flex align-center justify-space-between">
          <v-skeleton-loader type="text" width="30%" class="ma-0"></v-skeleton-loader>
          <v-skeleton-loader type="text" width="15%" class="ma-0"></v-skeleton-loader>
        </div>
        <div class="px-6 py-4 flex-grow-1 d-flex flex-column justify-space-around">
          <v-skeleton-loader v-for="i in 4" :key="i" type="text" width="100%" class="my-2"></v-skeleton-loader>
        </div>
      </template>

      <v-divider class="mt-1"></v-divider>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
import UserService from '../../../services/user.service';

export default {
  name: "CapturePlaylistsWidget",
  data() {
    return {
      loading: false,
      playlists: [],
      headers: [
        {
          text: this.$t("playerDetail.name"),
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: this.$t("table.usersOfClient.created"),
          value: "createdTime",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("general.lastVisit"),
          value: "usedTime",
          align: "center",
          sortable: false,
        },
      ]
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  async created() {
    await this.loadViewData();
  },
  methods: {
    async loadViewData(){
      this.loading = true;
      const playlistsData = await UserService.getAllPlaylists();
      this.playlists = _.chain(playlistsData.data).map(p => {
        p.filtersParsed = JSON.parse(p.filters);
        p.createdTime = moment(p.createdAt,'DD/MM/YYYY HH:mm').unix();
        p.usedTime = moment(p.usedAt,'DD/MM/YYYY HH:mm').unix();
        return p;
      }).orderBy(['usedTime','createdTime','name'],['desc','desc','asc']).value();
      this.loading = false;
    },
  }
};
</script>